import React, {FunctionComponent} from 'react';

interface OwnProps extends React.HTMLProps<HTMLDivElement>{
    children?: React.ReactNode
}

type Props = OwnProps;

const THead: FunctionComponent<Props> = ({className, children, ...rest}) => {

  return (
      <div  {...rest} role={'rowgroup'} className={`md:table-row-group hidden font-bold border-t ${className}`}>
          {children}
      </div>
  );
};

export default THead;
